module.exports = __webpack_public_path__ + "icon_pankkikortit.5fe391b12c959e167dec.svg";